import * as React from 'react';
import { Box, Grid, Avatar, Drawer, Container } from '@mui/material';
import Button from '@mui/material/Button';
import Rating from '@mui/material/Rating';
import HighlightOffSharpIcon from '@mui/icons-material/HighlightOffSharp';
import IconButton from '@mui/material/IconButton';
import { useEffect } from 'react';
import Divider from '@mui/material/Divider';
import PinDropRoundedIcon from '@mui/icons-material/PinDropRounded';
import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded';
import { useDispatch, useSelector } from 'react-redux';
import { SetRoute, UpdateCurrentLine, fetchLine } from '../../store/features/line';
import { timelineItemClasses } from '@mui/lab/TimelineItem';
import RouteRoundedIcon from '@mui/icons-material/RouteRounded';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from '@mui/lab';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import { Link } from 'react-router-dom';
import RichTextDrawer from './RichTextDrawer';


export default function Line(props) {
  const dispatch = useDispatch();
  const [descOpen, setDescOpen] = React.useState(false);
  const [descContent, setDescContent] = React.useState('');
  const [descTitle, setDescTitle] = React.useState('');

  const clickHandler = (e) => {
    // 新逻辑：点击线路，仅弹出富文本 Drawer，内容来自 e.desc
    console.log('line item clicked:', e);
    setDescTitle(e?.name || '');
    setDescContent(e?.desc || '');
    setDescOpen(true);
    return;

    // return;

    let waypoints = null;
    let route = null;
    if (e.spots.length > 1) {
      if (e.spots.length > 2) {
        waypoints = e.spots.slice(1, -1);
      }
      waypoints = waypoints.map(e => (
        e.end_spot.split(',')
      ))

      route = {
        waypoints: waypoints,
        startLngLat: e.spots[0].end_spot.split(','),
        endLngLat: e.spots[e.spots.length - 1].end_spot.split(','),
      }
      dispatch(SetRoute(route))
      dispatch(UpdateCurrentLine(e));
    }


    let arr = e.spots.map((item) => (
      {
        ...item,
        title: e.name,
        mapData: mapData.find(_e => (
          _e.id == item.scenic_id
        ))
      }
    )
    )

    console.log(arr)

    setSubData(arr);
    setShowSub(true);
  }
  const clickHandler2 = (e) => {
    // dispatch(fetchLine)
    console.log(e);
    // setShowSub(e);
  }


  const storageURL = process.env.REACT_APP_Stroage_URL;
  const data = useSelector((store) => store.line.data);

  const [showsub, setShowSub] = React.useState(false);
  const [subdata, setSubData] = React.useState(null);
  const { mapData } = useSelector((store) => store.maps);

  const jumpHandler = (data) => {
    console.log(data);
    // dispatch(UpdateCurrentLine(props.data));
  }

  const countLiCheng = (arr) => {
    let total = 0;
    arr.forEach(element => {
      total += parseInt(element.mileage)
    });
    return (total / 1000).toFixed(1) + '公里'
  }
  const countDur = (arr) => {
    let total = 0;
    arr.forEach(element => {
      total += parseInt(element.duration)
    });

    const minutes = Math.floor(total / 60);

    // 计算剩余的秒数
    const remainingSeconds = total % 60;

    // 将分钟和秒数格式化为两位数的字符串
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(remainingSeconds).padStart(2, '0');

    return formattedMinutes + '分' + formattedSeconds + '秒'
  }


  useEffect(() => {
    dispatch(fetchLine());
  }, []);

  useEffect(() => {
    if (!props.showLine) {
      setShowSub(false);
    }
  }, [props.showLine]);

  return (
    <>
      <Drawer
        className=''
        anchor={"bottom"}
        open={props.showLine}
        onClose={props.closeHandler}
        sx={{
          '& .MuiPaper-root': {
            borderTopLeftRadius: "15px !important",
            borderTopRightRadius: "15px !important",
            maxHeight: '95vh',
            height: '95vh',
          },
        }}
      >
        <IconButton style={{ position: 'absolute', right: '10px', top: "10px" }} aria-label="delete" size="meduim" onClick={props.closeHandler}>
          <HighlightOffSharpIcon fontSize='meduim' />
        </IconButton>
        {!showsub && <Container sx={{ padding: 0 }}>
          <Grid sx={{ background: "#ffffff", margin: "10px 10px 0 10px", padding: '0px 10px 10px 10px', borderRadius: '10px' }}>
            <Grid container spacing={1} marginTop={0}>
              <Grid item>
                <WorkspacePremiumRoundedIcon sx={{ fontSize: 25 }} color='mgreen'></WorkspacePremiumRoundedIcon >
              </Grid>
              <Grid item sx={{ fontWeight: "bold", marginTop: "2px" }}>
                推荐旅游线路
              </Grid>
              <div style={{ background: 'rgba(0,0,0,.1)', height: '1px', width: "100%", margin: "1rem 0.0rem 0 0.0rem" }}></div>
            </Grid>
          </Grid>
          <Container>
            {
              data && data.map((item, index) => (
                <Grid key={index} container spacing={.5} sx={{ fontSize: "small" }} onClick={() => { clickHandler(item) }}>
                  <Grid item>
                    {item.name}
                  </Grid>
                  <Grid item container spacing={2} sx={{ color: '#999', letterSpacing: "1px" }}>
                    <Grid item xs={6}>
                      <RouteRoundedIcon color='mgreen' size='small' sx={{ fontSize: "15px", marginRight: "2px" }}></RouteRoundedIcon>{'里程:' + countLiCheng(item.spots)}
                    </Grid>
                    <Grid item xs={6}>
                      <AccessTimeRoundedIcon color='mgreen' size='small' sx={{ fontSize: "15px", marginRight: "2px" }}></AccessTimeRoundedIcon>
                      {'时长:' + countDur(item.spots)}
                    </Grid>
                  </Grid>
                  <div style={{ background: 'rgba(0,0,0,.1)', height: '1px', width: "100%", margin: "0.5rem 0.5rem" }}></div>

                </Grid>

              ))
            }
          </Container>
        </Container>
        }
        {showsub && <Container sx={{ padding: 0 }}>
          <Grid container>
            <Grid item container xs={12}>
              <Grid container item xs={10} sx={{ justifyContent: 'flex-start', fontWeight: "bold", padding: "15px 15px 10px 15px" }}>
                <Grid item xs={1}>
                  <PinDropRoundedIcon size='meduim' color='mgreen'></PinDropRoundedIcon>
                </Grid>
                <Grid item xs={11}>
                  {subdata && subdata[0].title}
                </Grid>
              </Grid>
              <Grid item container xs={12} sx={{ fontSize: 'small', padding: "2px 18px", color: '#999', letterSpacing: "1px" }}>
                <Grid item sx={{ marginRight: "15px" }}>
                  <RouteRoundedIcon color='mgreen' sx={{ fontSize: "15px", marginRight: "2px" }}></RouteRoundedIcon>{'里程:' + countLiCheng(subdata)}</Grid>
                <Grid item ><AccessTimeRoundedIcon color='mgreen' size='small' sx={{ fontSize: "15px", marginRight: "2px" }}></AccessTimeRoundedIcon>{'时长:' + countDur(subdata)}</Grid>
              </Grid>
            </Grid>
            <Grid container item xs={12} justifyContent={'flex-end'} style={{ marginTop: "-1.8rem" }}>
              <Grid item xs={2.5} sx={{ marginTop: '0.2rem' }} onClick={() => jumpHandler(data)}>
                <Link to="/linedetail" style={{ display: 'flex', justifyContent: 'flex-end', marginRight: '15px' }}>
                  <Button style={{ fontSize: '0.6125rem' }} size="small" color='mgreen' variant={'outlined'} >
                    查看详情
                  </Button>
                </Link>
              </Grid>
            </Grid>

            <Grid item xs={12}>

              <Timeline
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                }}
              >
                {
                  subdata && subdata.map((item, index) => (
                    <TimelineItem key={index}>
                      {/* <TimelineOppositeContent color="mgreen" sx={{ fontSize: "0.5rem" }}>
                      09:30
                    </TimelineOppositeContent> */}
                      <TimelineSeparator>
                        <TimelineDot variant="outlined" color="mgreen" />
                        <TimelineConnector />
                      </TimelineSeparator>
                      <TimelineContent>

                        <Grid container spacing={2}>
                          <Grid item xs={4}>
                            <img style={{ objectFit: 'cover', borderRadius: '5px' }} src={storageURL + item.mapData.thumb} alt="" />
                          </Grid>
                          <Grid item container xs={8} style={{ fontSize: "12px" }}>
                            <Grid item xs={12}>{item.mapData.name}</Grid>
                            <Grid item xs={12}>{item.mapData.addr}</Grid>
                          </Grid>
                        </Grid>
                      </TimelineContent>
                    </TimelineItem>
                  ))
                }
              </Timeline>


            </Grid>
            {/* <Grid container item xs={8}>
            {
              subdata && subdata.map((item, index) => (
                <Grid key={index} container spacing={.5} sx={{ fontSize: "small" }} onClick={() => { clickHandler(item) }}>
                  <Grid item>
                    {item.name}
                  </Grid>
                  <Grid item container spacing={2}>
                    <Grid item xs={4}>
                      {'里程'}
                    </Grid>
                    <Grid item xs={4}>
                      {'时长'}
                    </Grid>
                  </Grid>

                </Grid>
              ))
            }
          </Grid> */}
          </Grid>
        </Container>
        }
      </Drawer >

      {/* 富文本介绍 Drawer：e.desc */}
      <RichTextDrawer
        open={descOpen}
        onClose={() => setDescOpen(false)}
        title={descTitle}
        content={descContent}
      />
    </>
  );
}